<template>
  <div
    class="cg-popover"
    :class="flip ? 'cg-popover--below' : 'cg-popover--above'"
    :style="{ left }"
  >
    <div class="d-flex justify-content-between align-items-baseline gap-2 mb-2">
      <p class="mb-0 fw-semibold small">{{ cell.period }}</p>
      <ToneBadge :tone="cell.tone" :label="cell.statusLabel" />
    </div>
    <dl class="cg-rows small mb-0">
      <template v-for="row in cell.detail" :key="row.k">
        <dt class="text-body-secondary fw-normal">{{ row.k }}</dt>
        <dd class="mb-0 fw-semibold cg-tabular text-end">{{ row.v }}</dd>
      </template>
    </dl>
    <p
      v-if="cell.note"
      class="mb-0 mt-2 pt-2 text-body-secondary small cg-note"
    >
      {{ cell.note }}
    </p>
  </div>
</template>

<script setup lang="ts">
import type { StripCell } from "@/compliance_groups/fixture/derive";
import ToneBadge from "./ToneBadge.vue";

defineProps<{ cell: StripCell; left: string; flip: boolean }>();
</script>

<style scoped lang="scss">
.cg-popover--above {
  bottom: calc(100% + 8px);
}
.cg-popover--below {
  top: calc(100% + 8px);
}
.cg-rows {
  display: grid;
  grid-template-columns: max-content 1fr;
  column-gap: 12px;
  row-gap: 3px;
  align-items: baseline;
}
.cg-note {
  border-top: 1px solid var(--phoenix-border-color);
}
</style>
